import { render, staticRenderFns } from "./Bodegas.vue?vue&type=template&id=a7230cce&scoped=true"
import script from "./Bodegas.vue?vue&type=script&lang=js"
export * from "./Bodegas.vue?vue&type=script&lang=js"
import style0 from "./Bodegas.vue?vue&type=style&index=0&id=a7230cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7230cce",
  null
  
)

export default component.exports